import React from 'react';
import '../styles/Dot.scss';

class Dot extends React.Component {

    render() {
        return <div className={this.props.active ? `steps active` : `steps`}
    onClick={e => this.props.onDotClick(this.props.dataIndex, e)}/>
    }
}

export default Dot;